if (!customElements.get('aur-product-carousel')) {
  customElements.define('aur-product-carousel', class extends HTMLElement {
    connectedCallback() {
      this.grid = this.querySelector('.aur-prod-grid');
      this.previous = this.querySelector('.aur-carousel-prev');
      this.next = this.querySelector('.aur-carousel-next');
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const update = () => {
        const max = this.grid.scrollWidth - this.grid.clientWidth;
        this.previous.hidden = this.grid.scrollLeft < 2;
        this.next.hidden = max < 2 || this.grid.scrollLeft >= max - 2;
      };
      const move = (direction) => {
        const card = this.grid.querySelector('.aur-p-card');
        if (!card) return;
        const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(this.grid).columnGap || 0);
        this.grid.scrollBy({ left: direction * step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      };
      this.previous.addEventListener('click', () => move(-1), options);
      this.next.addEventListener('click', () => move(1), options);
      this.grid.addEventListener('scroll', update, options);
      this.observer = new ResizeObserver(update);
      this.observer.observe(this.grid);
      update();
    }
    disconnectedCallback() {
      this.controller.abort();
      this.observer.disconnect();
    }
  });
}
